var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from "react";
import { SurveyQuestionElementBase } from "./reactquestion_element";
import { ReactQuestionFactory } from "./reactquestion_factory";
import { SvgIcon } from "./components/svg-icon/svg-icon";
import { LoadingIndicatorComponent } from "./components/loading-indicator";
var SurveyQuestionSignaturePad = /** @class */ (function (_super) {
    __extends(SurveyQuestionSignaturePad, _super);
    function SurveyQuestionSignaturePad(props) {
        var _this = _super.call(this, props) || this;
        _this.state = { value: _this.question.value };
        return _this;
    }
    Object.defineProperty(SurveyQuestionSignaturePad.prototype, "question", {
        get: function () {
            return this.questionBase;
        },
        enumerable: false,
        configurable: true
    });
    SurveyQuestionSignaturePad.prototype.renderElement = function () {
        var _this = this;
        var cssClasses = this.question.cssClasses;
        var loadingIndicator = this.question.showLoadingIndicator ? this.renderLoadingIndicator() : null;
        var clearButton = this.renderCleanButton();
        return (React.createElement("div", { className: cssClasses.root, ref: function (root) { return (_this.setControl(root)); }, style: { width: this.question.renderedCanvasWidth } },
            React.createElement("div", { className: cssClasses.placeholder, style: { display: this.question.needShowPlaceholder() ? "" : "none" } }, this.renderLocString(this.question.locRenderedPlaceholder)),
            React.createElement("div", null,
                this.renderBackgroundImage(),
                React.createElement("canvas", { tabIndex: -1, className: this.question.cssClasses.canvas, onBlur: function (event) { _this.question.onBlur(event); } })),
            clearButton,
            loadingIndicator));
    };
    SurveyQuestionSignaturePad.prototype.renderBackgroundImage = function () {
        if (!this.question.backgroundImage)
            return null;
        return React.createElement("img", { className: this.question.cssClasses.backgroundImage, src: this.question.backgroundImage, style: { width: this.question.renderedCanvasWidth }, role: "presentation" });
    };
    SurveyQuestionSignaturePad.prototype.renderLoadingIndicator = function () {
        return React.createElement("div", { className: this.question.cssClasses.loadingIndicator },
            React.createElement(LoadingIndicatorComponent, null));
    };
    SurveyQuestionSignaturePad.prototype.renderCleanButton = function () {
        var _this = this;
        if (!this.question.canShowClearButton)
            return null;
        var cssClasses = this.question.cssClasses;
        return React.createElement("div", { className: cssClasses.controls },
            React.createElement("button", { type: "button", className: cssClasses.clearButton, title: this.question.clearButtonCaption, onClick: function () { return _this.question.clearValueFromUI(); } },
                this.question.cssClasses.clearButtonIconId ? React.createElement(SvgIcon, { iconName: this.question.cssClasses.clearButtonIconId, size: "auto" }) : React.createElement("span", null, "\u2716"),
                " "));
    };
    return SurveyQuestionSignaturePad;
}(SurveyQuestionElementBase));
export { SurveyQuestionSignaturePad };
ReactQuestionFactory.Instance.registerQuestion("signaturepad", function (props) {
    return React.createElement(SurveyQuestionSignaturePad, props);
});
